
import LinkMenu from './LinkMenu';
import styles from './NavBar.module.scss';
import { useState } from 'react';
import LanguageIcon from '@mui/icons-material/Language';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useLangContext } from '../../Context/LanguageContext';

export default function NavBar() {
  const { updateLang } = useLangContext();
  const [menuOpen, setMenuOpen] = useState(false);

  // Fecha o menu ao clicar em um link
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>My Blog</div>
      <button
        className={styles.menuButton}
        aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
        onClick={() => setMenuOpen((open) => !open)}
      >
        {menuOpen ? <CloseIcon sx={{ color: 'white' }} /> : <MenuIcon sx={{ color: 'white' }} />}
      </button>
      <div
        className={styles.navLinks + ' ' + (menuOpen ? styles.open : '')}
        onClick={handleLinkClick}
      >
        <LinkMenu to='/'>Front Page</LinkMenu>
        <LinkMenu to='/posts'>Posts</LinkMenu>
        <LinkMenu to='/contato'>Contact</LinkMenu>
        {/* <LinkMenu to='/count'>Cont</LinkMenu> */}
        {/* <LinkMenu to='/artigo'>Api</LinkMenu> */}
        <LinkMenu to='/news'>Tech News</LinkMenu>
        <LanguageIcon
          onClick={(e) => {
            e.stopPropagation();
            updateLang();
          }}
          sx={{
            color: 'white',
            cursor: 'pointer',
            verticalAlign: 'middle',
          }}
        />
      </div>
    </nav>
  );
}
